export const UNAVAILABLE_SOURCE_DASHBOARD = 'dashboard';
